"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatSite;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immer = _interopRequireDefault(require("immer"));

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function formatSite(site) {
  var nextSite = (0, _immer.default)(site, function (draft) {
    // Convert posts and then post types to object structure
    if ((0, _lodash.get)(draft, "postTypes.items")) {
      draft.postTypes.items.map(function (o, i) {
        if ((0, _lodash.get)(o, "posts.items")) {
          return draft.postTypes.items[i].posts = draft.postTypes.items[i].posts.items.reduce(function (ac, a) {
            return _objectSpread(_objectSpread({}, ac), {}, _defineProperty({}, a.id, a));
          }, {});
        }

        return null;
      });
      draft.postTypes = draft.postTypes.items.reduce(function (ac, a) {
        return _objectSpread(_objectSpread({}, ac), {}, _defineProperty({}, a.id, a));
      }, {});
    } // Convert taxonomies to object structure


    if ((0, _lodash.get)(draft, "taxonomies.items")) {
      draft.taxonomies = draft.taxonomies.items.reduce(function (ac, a) {
        return _objectSpread(_objectSpread({}, ac), {}, _defineProperty({}, a.id, a));
      }, {});
    }
  });
  return nextSite;
}